export const DisclaimerStyles = {
  container: (alignCenter: boolean = false) =>
    `text-goEasyGray900 font-normal text-sm w-auto mb-5 text-center text-black ${alignCenter ? 'px-10' : '1xl:text-left'}`,
}
